import { CartButtonWithCount } from '@/components/cart-button-with-count'
import { FitpetTitleHeader } from '@/components/domains/layouts/header/fitpet-title-header'
import ListOrdersHistory from '@/components/domains/order/ListOrdersHistory'
import styles from './index.page.module.css'

const PageMyPageOrderList = () => {
  return (
    <>
      <FitpetTitleHeader title="주문·배송 내역" rightNode={<CartButtonWithCount />} />
      <div className={styles.wrapper}>
        <ListOrdersHistory />
      </div>
    </>
  )
}

export default PageMyPageOrderList
